import { render, staticRenderFns } from "./RequiredMessageModal.vue?vue&type=template&id=596e6609"
import script from "./RequiredMessageModal.vue?vue&type=script&lang=js"
export * from "./RequiredMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports